import * as actionTypes from 'constants/ActionTypes';

export function getLetter(id) {
    return {
        type: actionTypes.GET_LETTER.REQUEST,
        id,
    };
}

export function updateLetter(id, letter, typeLetter) {
    return {
        type: actionTypes.UPDATE_LETTER.REQUEST,
        id,
        letter,
        typeLetter,
    };
}

export function removeLetter() {
    return {
        type: actionTypes.REMOVE_LETTER,
    };
}



// WEBPACK FOOTER //
// ./app/actions/letters.js